export const STORAGE_KEYS = {
  TOKEN: 'token',
  ADDING_TEAM: 'adding_team',
  REMEMBER_ME: 'remember_me',
  REMEMBER_EMAIL: 'remember_email',
  REMEMBER_PASSWORD: 'remember_password',
  REMEMBER_ROLE: 'remember_role',
}
